
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams){
    const hasParam1 = urlParams.has('installation');
    
    if (hasParam1){
    document.addEventListener('DOMContentLoaded', function() {
    
        const element = document.querySelector('.tabs');

        console.log(`Does 'tabs' element exist? ${element}`); 

        // Ensure the element exists before attempting to scroll
        if (element) {
            const headerElement = document.querySelector('sticky-header');
            if (headerElement){
                const headerHeight =  headerElement.offsetHeight; 
                element.style.scrollMarginTop  =  `${headerHeight}px`;
            }

            // Use a small timeout to ensure the browser has finished its
            // initial rendering pass and accurately calculated header height.
            setTimeout(() => {
                element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
                });
            }, 50); 
        }
    
    });
    }
}




